import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate,useLocation } from 'react-router-dom';
import { FaRegCircleUser } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import ROLE from '../common/role';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import uploadImage from '../helpers/uploadImage';

const UserEditProfile = () => {
  const user = useSelector((state) => state?.user?.user);
  
  const location = useLocation();
  const navigate = useNavigate();
  const [profilePic, setProfilePic] = useState(user?.profilePic || '');
  const [editableUser, setEditableUser] = useState({
    name: user?.name || '',
    shippingAddress: user?.shippingAddress || '',
    mobileNumber: user?.mobileNumber || '',
    purchasingManager: user?.purchasingManager || '',
    
  });
  const [loading, setLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoading(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.GENERAL) {
        
        navigate("/");
        setLoading(false);
      } 
      else {
        setLoading(false);
        clearTimeout(loadingTimeout)
        fetchUserDetails()
        
      }
    } 

    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);




  
    const fetchUserDetails = async () => {
      try {
        
        const response = await fetch(SummaryApi.current_user.url, {
          method: SummaryApi.current_user.method,
          credentials: 'include',
          headers: {
            'content-type': 'application/json',
          },
        });
        const responseData = await response.json();
        if (responseData.success) {
          setEditableUser({
            name: responseData.data.name,
            shippingAddress: responseData.data.shippingAddress,
            mobileNumber: responseData.data.mobileNumber,
            purchasingManager: responseData.data.purchasingManager,
          });
          setProfilePic(responseData.data.profilePic || '');
        } else {
          toast.error(responseData.message || 'حدث خطأ');
        }
      } catch (error) {
        toast.error('حدث خطأ');
      } 
    };



  const handleChange = (e) => {
    setEditableUser({
      ...editableUser,
      [e.target.name]: e.target.value,
    });
  };

  const handleUploadPic = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const uploadImageCloudinary = await uploadImage(file);
      setProfilePic(uploadImageCloudinary.url);
    }
  };

  const handleRemovePic = () => {
    setProfilePic('');
  };

  const handleSave = async () => {
    try {
      
      const response = await fetch(SummaryApi.editProfile.url, {
        method: SummaryApi.editProfile.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: user?._id,
          name: editableUser.name,
          shippingAddress: editableUser.shippingAddress,
          mobileNumber: editableUser.mobileNumber,
          profilePic: profilePic || null, // Send null if profilePic is empty
          purchasingManager:editableUser.purchasingManager
        }),
      });
      const result = await response.json();
  
      if (result.success) {
        toast.success('تم تعديل الملف الشخصي بنجاح');
      } else {
        toast.error(result.message || 'فشل تحديث الملف الشخصي');
      }
    } catch (error) {
      toast.error('حدث خطأ أثناء تحديث الملف الشخصي');
    } 
  };

  const hasChanges = profilePic !== user?.profilePic || editableUser.name !== user?.name || editableUser.shippingAddress !== user?.shippingAddress || editableUser.mobileNumber !== user?.mobileNumber || editableUser.purchasingManager !== user?.purchasingManager;

  if (loading) {
    
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }


  return (
    <div className="min-h-[calc(100vh-120px)] lg:flex">
            <button onClick={toggleSidebar} className="lg:hidden fixed top-20 left-4 z-50 bg-blue-900 text-white p-2 rounded-full">
        {isSidebarOpen ? <AiOutlineClose size={18} /> : <AiOutlineMenu size={18} />}
      </button>
      {/* Sidebar */}
      <aside className={`lg:block w-full max-w-60 customShadow transition-transform duration-300 ease-in-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                  fixed lg:relative z-10 bg-white lg:bg-transparent lg:translate-x-0 h-full lg:h-auto top-18`}>
  <div className='h-32 flex justify-center items-center flex-col'>
    <div className='text-5xl cursor-pointer relative flex justify-center'>
      {user?.profilePic ? (
        <img src={user?.profilePic} className='w-20 h-20 rounded-full' alt={user?.name} />
      ) : (
        <FaRegCircleUser />
      )}
    </div>
    <p className='capitalize text-lg font-semibold'>{user?.name}</p>
    <p className='text-sm'>{user?.pharmacistOrPharmacy === 'pharmacy' ? 'صيدلية' : user?.pharmacistOrPharmacy === 'pharmacist' ? 'عميل' : user?.pharmacistOrPharmacy}</p>
  </div>

  {/* Navigation */}
  <div>
    <nav className='grid p-4'>
      {/* معلومات شخصية */}
      <div className='mb-4'>
        <h3 className='text-xl font-bold mb-2 text-center'>المعلومات الشخصية</h3>
        <Link
          to='/userProfile'
          className={`block px-2 py-1 ${location.pathname === '/userProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          الملف الشخصي
        </Link>
        <Link
          to='/userEditProfile'
          className={`block px-2 py-1 ${location.pathname === '/userEditProfile' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          تعديل الملف الشخصي
        </Link>
        <Link
          to='/changePassword'
          className={`block px-2 py-1 ${location.pathname === '/changePassword' ? 'bg-slate-200 font-bold' : 'hover:bg-slate-100'} text-right`}
        >
          تغيير كلمة المرور
        </Link>
      </div>


    </nav>
  </div>
</aside>

    <main className={`w-full h-full p-2 ${isSidebarOpen ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
        <div className="container max-w-xl mx-auto p-5 " style={{ marginLeft: '20px' }}>
          <h2 className="text-2xl font-bold mb-5">تعديل الملف الشخصي</h2>

          {loading ? (
            <div className="h-32 bg-slate-200 animate-pulse"></div>
          ) : (
            <div className="space-y-4">
              <div className="flex items-center ">
                <div className="w-20 h-20 rounded-full overflow-hidden mr-4 ">
                  <img src={profilePic || user?.profilePic || 'placeholder.png'} alt="Profile" className="w-full h-full object-cover" />
                </div>
                <input type="file" accept="image/*" onChange={handleUploadPic} className="hidden" id="profilePicInput" />
                <label htmlFor="profilePicInput" className="cursor-pointer bg-gray-300 p-2 ">
                تحميل صورة جديدة
                </label>
                {profilePic && (
                  <button
                    onClick={handleRemovePic}
                    className="ml-4 bg-red-500  hover:bg-red-700 text-white p-2 "
                  >
                    إزالة الصورة الحالية
                  </button>
                )}
              </div>
              {user?.pharmacistOrPharmacy === 'pharmacy' && (
              <div>
                <div className="text-right">
                  <h3 className="font-semibold">: مدير المشتريات </h3>
                </div>
                <input
                  type="text"
                  name="purchasingManager"
                  value={editableUser.purchasingManager}
                  onChange={handleChange}
                  className="border rounded p-1 w-full bg-gray-50 text-sm"
                />
              </div>

              )}

              <div>
                <div className="text-right">
                  <h3 className="font-semibold">: عنوان التوصيل</h3>
                </div>
                <input
                  type="text"
                  name="shippingAddress"
                  value={editableUser.shippingAddress}
                  onChange={handleChange}
                  className="border rounded p-1 w-full bg-gray-50 text-sm"
                />
              </div>

              <div>
                <div className="text-right">
                  <h3 className="font-semibold">: رقم الهاتف المحمول</h3>
                </div>
                <input
                  type="text"
                  name="mobileNumber"
                  value={editableUser.mobileNumber}
                  onChange={handleChange}
                  className="border rounded p-1 w-full bg-gray-50 text-sm"
                />
              </div>

              <button
                onClick={handleSave}
                className="bg-blue-900 text-white p-2 mt-4"
                disabled={loading || !hasChanges}
              >
                حفظ التعديلات
              </button>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default UserEditProfile;
